import orgApiV4 from "../clients/org-api-v4";

export const generateTenantMeilisearchKey = async (): Promise<string> => {
  const { data } = await orgApiV4.post<string>("/generate-search-key");

  return data;
};
